var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteToVideoChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2134_7377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4533 0.986572H3.54667C2.87125 0.986572 2.22349 1.25488 1.7459 1.73247C1.26831 2.21007 1 2.85782 1 3.53324V9.89324C1 10.5687 1.26831 11.2164 1.7459 11.694C2.22349 12.1716 2.87125 12.4399 3.54667 12.4399H6.09333L8 14.3466L9.90667 12.4399H12.4533C13.1288 12.4399 13.7765 12.1716 14.2541 11.694C14.7317 11.2164 15 10.5687 15 9.89324V3.53324C15 2.85782 14.7317 2.21007 14.2541 1.73247C13.7765 1.25488 13.1288 0.986572 12.4533 0.986572Z",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64007 4.80005H4.82007V9.25338H8.64007V4.80005Z",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63989 6.71331V7.34664L10.5466 9.25997H11.1799V4.80664H10.5466L8.63989 6.71331Z",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2134_7377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteToVideoChat);
export default __webpack_public_path__ + "static/media/inviteToVideoChat.77103d59661c23aa34c54012cae1f4b7.svg";
export { ForwardRef as ReactComponent };